var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        {
          ref: "addForm",
          attrs: {
            model: _vm.addData,
            rules: _vm.rules,
            "label-width": "100px",
            size: "mini"
          }
        },
        [
          _vm._l(_vm.paramsList, function(param) {
            return _c(
              "el-form-item",
              { key: param.code, attrs: { label: param.name + "：" } },
              [
                param.display === "input"
                  ? _c("el-input", {
                      staticStyle: { width: "180px" },
                      attrs: { type: "text" },
                      model: {
                        value: param.value,
                        callback: function($$v) {
                          _vm.$set(param, "value", $$v)
                        },
                        expression: "param.value"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                param.display === "textArea"
                  ? _c("el-input", {
                      staticStyle: { width: "220px" },
                      attrs: { type: "textarea", rows: 4 },
                      model: {
                        value: param.value,
                        callback: function($$v) {
                          _vm.$set(param, "value", $$v)
                        },
                        expression: "param.value"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                param.display === "numberInput"
                  ? _c("el-input-number", {
                      attrs: { min: 1, label: "描述文字" },
                      model: {
                        value: param.value,
                        callback: function($$v) {
                          _vm.$set(param, "value", $$v)
                        },
                        expression: "param.value"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                param.display === "time"
                  ? _c("el-time-picker", {
                      attrs: {
                        "value-format": "HH:mm:ss",
                        placeholder: "任意时间点"
                      },
                      model: {
                        value: param.value,
                        callback: function($$v) {
                          _vm.$set(param, "value", $$v)
                        },
                        expression: "param.value"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                param.display === "checkbox"
                  ? _c(
                      "div",
                      _vm._l(
                        param.option ? param.option.split(",") : [],
                        function(p) {
                          return _c(
                            "el-checkbox",
                            {
                              key: p.split(":")[0],
                              attrs: { label: p.split(":")[0] + "" },
                              model: {
                                value: param.value,
                                callback: function($$v) {
                                  _vm.$set(param, "value", $$v)
                                },
                                expression: "param.value"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(p.split(":")[0]) +
                                  _vm._s(p.split(":")[1])
                              )
                            ]
                          )
                        }
                      ),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                param.display === "radio"
                  ? _c(
                      "div",
                      _vm._l(param.option.split(","), function(o) {
                        return _c(
                          "el-radio",
                          {
                            key: o,
                            attrs: { label: o.split(":")[0] },
                            model: {
                              value: param.value,
                              callback: function($$v) {
                                _vm.$set(param, "value", $$v)
                              },
                              expression: "param.value"
                            }
                          },
                          [_vm._v(_vm._s(o.split(":")[1]))]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                param.display === "select"
                  ? _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "请选择" },
                        model: {
                          value: param.value,
                          callback: function($$v) {
                            _vm.$set(param, "value", $$v)
                          },
                          expression: "param.value"
                        }
                      },
                      _vm._l(param.option.split(","), function(map) {
                        return _c("el-option", {
                          key: map,
                          attrs: {
                            label: map.split(":")[1],
                            value: map.split(":")[0]
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                param.display === "audio" ||
                param.display === "video" ||
                param.display === "img"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-demo",
                            attrs: {
                              "http-request": _vm.fnUploadRequest,
                              action: "string",
                              "on-success": function(res) {
                                return _vm.onsuccess(res, param.display)
                              },
                              "show-file-list": false
                            }
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "small", type: "primary" } },
                              [_vm._v("点击上传")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        param.display === "img"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "vuedraggable",
                                  {
                                    model: {
                                      value: _vm.imageList,
                                      callback: function($$v) {
                                        _vm.imageList = $$v
                                      },
                                      expression: "imageList"
                                    }
                                  },
                                  [
                                    _c(
                                      "transition-group",
                                      _vm._l(_vm.imageList, function(
                                        item,
                                        index
                                      ) {
                                        return _c("div", { key: item }, [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                item.substr(
                                                  item.lastIndexOf("/") + 1
                                                )
                                              ) + "\n                    "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "delete",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleDelList(
                                                      _vm.imageList,
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("×")]
                                            )
                                          ])
                                        ])
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        param.display === "audio"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "vuedraggable",
                                  {
                                    model: {
                                      value: _vm.audioList,
                                      callback: function($$v) {
                                        _vm.audioList = $$v
                                      },
                                      expression: "audioList"
                                    }
                                  },
                                  [
                                    _c(
                                      "transition-group",
                                      _vm._l(_vm.audioList, function(item) {
                                        return _c("div", { key: item }, [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                item.substr(
                                                  item.lastIndexOf("/") + 1
                                                )
                                              ) + "\n                     "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "delete",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleDelList(
                                                      _vm.audioList,
                                                      _vm.index
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("×")]
                                            )
                                          ])
                                        ])
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        param.display === "video"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "vuedraggable",
                                  {
                                    model: {
                                      value: _vm.videoList,
                                      callback: function($$v) {
                                        _vm.videoList = $$v
                                      },
                                      expression: "videoList"
                                    }
                                  },
                                  [
                                    _c(
                                      "transition-group",
                                      _vm._l(_vm.videoList, function(item) {
                                        return _c("div", { key: item }, [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                item.substr(
                                                  item.lastIndexOf("/") + 1
                                                )
                                              ) + "\n                     "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "delete",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleDelList(
                                                      _vm.videoList,
                                                      _vm.index
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("×")]
                                            )
                                          ])
                                        ])
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: " " } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }